import Loadable from '../../components/loadable';

const VerifyPhoneNumberModal = Loadable({
  loader: () => import('../../pages/user_profile/verify_phone_number_modal'),
  type: 'modal',
});

angular.module('gym').value('VerifyPhoneNumberModal', VerifyPhoneNumberModal);
